<template>
  <div class="h100vh-140">
    <div class="h-wrapper-680">
      <div class="h-dialogContainer">
        <form id="passwordForm">
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('Security.Strategy.pwdMinNumber')}}:</div>
                <div class="e-input-group e-control-wrapper">
                  <input class="e-control e-textbox e-lib e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="passwordByte" name="PasswordByte" v-model="passwordByte" maxlength="10" />
                </div>
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <ejs-checkbox :label="$t('Security.Strategy.shortInterval')" ref="passwordRange" :checked="true" :change="setRangeState"></ejs-checkbox>
                <input class="e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="passwordRange" name="PasswordRange" v-model="passwordRange" maxlength="4" />
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('Security.Strategy.constitute')}}:</div>
                <ejs-radiobutton class="h-inputLit" ref="passwordComRadio" name="PasswordCom" :label="$t('Security.Strategy.onlyNumChar')" :checked='passwordCom'></ejs-radiobutton>
                <ejs-radiobutton class="h-inputLit" name="PasswordCom" :label="$t('Security.Strategy.special')" :checked='!passwordCom'></ejs-radiobutton>
              </div>
            </div>
          </div>
          <ejs-checkbox :label="$t('Security.Strategy.updPwd')" ref="changePassword" :checked="true" :change="setChangePassword"></ejs-checkbox>
          <div class="row h-row-inputBox">
            <div class="h-col-inputBox">
              <div class="h-borderBox h-blueBg">
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <div class="h-inputLit">{{$t('Security.Strategy.pwdPeriod')}}({{$t('Common.day')}})</div>
                    <input class="e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="validTime" name="ValidTime" v-model="validTime" maxlength="10" @change='setNoticeTip' />
                  </div>
                </div>
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <div class="h-inputLit">{{$t('Security.Strategy.remindDay')}}({{$t('Common.day')}})</div>
                    <input class="e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="noticeChange" name="NoticeChange" v-model="noticeChange" maxlength="10" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="">{{$t('Security.Strategy.updTipInfo')}}</div>
    </div>
    <div class="b-t"></div>
    <div class="h-scroll h-system-wrapper-680">
      <div class="h-bottom-btnBox h-system-btnBox" style="margin: -10px -120px;">
        <div class="row">
          <div class="col-sm-12 h-col-inputBox">
            <ejs-button cssClass="e-control e-btn e-lib e-primary e-flat" @click.native="save">{{$t('Common.save')}}</ejs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../mixin/mixin'
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "passwordStrategy",
  mixins: [mixin],
  data() {
    return {
      passwordByte: "",
      passwordRange: "",
      validTime: "",
      noticeChange: "",
      inputNames: ['PasswordByte', 'PasswordRange', 'ValidTime', 'NoticeChange'],
      rules: {
        PasswordByte: { required: true, number: true, min: 1, max: 20, regex: 'integer' },
        PasswordRange: { required: true, number: true, min: 5, max: 1440, regex: 'integer' },
        ValidTime: { required: true, number: true, min: 1, max: 360, regex: 'integer' },
        NoticeChange: { required: true, number: true, min: 1, regex: 'integer' }
      },
      formObj: "",
      passwordCom: true,
      strategyId: '',
      strategyType: 0
    };
  },
  methods: {
    setRangeState() {
      const checked = this.$refs.passwordRange.ej2Instances.checked;
      document.getElementById('passwordRange').disabled = !checked;
      this.formObj = this.validateForm('passwordForm', this.inputNames, this.rules);
      this.$refs.passwordRange.ej2Instances.refresh();
    },
    setChangePassword() {
      const checked = this.$refs.changePassword.ej2Instances.checked;
      document.getElementById('validTime').disabled = !checked;
      document.getElementById('noticeChange').disabled = !checked;
      this.formObj = this.validateForm('passwordForm', this.inputNames, this.rules);
      this.$refs.changePassword.ej2Instances.refresh();
    },
    setNoticeTip(){
      const reg = /^-?\d+$/;
      if (reg.test(this.validTime)) {
        this.rules['NoticeChange']['max'] = parseInt(this.validTime);
      } else {
        delete this.rules['NoticeChange']['max'];
      }
      this.formObj = this.validateForm('passwordForm', this.inputNames, this.rules);
    },
    save() {
      const formStatus = this.formObj.validate();
      if (!formStatus) {
        return null;
      }
      const url = '/lte/ems/strategy/editStrategy';
      const items = {};
      items['pwd.minLength'] = this.passwordByte;
      if (this.$refs.passwordRange.ej2Instances.checked) {
        items['pwd.updFlag'] = '1';
        items['pwd.updMinTime'] = this.passwordRange;
      } else {
        items['pwd.updFlag'] = '0';
        items['pwd.updMinTime'] = '5';
      }
      if (this.$refs.changePassword.ej2Instances.checked) {
        items['pwd.expireFlag'] = '1';
        items['pwd.period'] = this.validTime;
        items['pwd.remind'] = this.noticeChange;
      } else {
        items['pwd.expireFlag'] = '0';
      }
      if (this.$refs.passwordComRadio.ej2Instances.checked) {
        items['pwd.constitute'] = '1';
      } else {
        items['pwd.constitute'] = '0';
      }
      const params = {
        strategyType: this.strategyType,
        strategyId: this.strategyId,
        items: items
      };
      let That = this;
      this.axios.post(url, params).then(response => {
        const result = response.data;
        if (result) {
          That.eventEmit('success', `${this.$t("Common.tips.success")}`);
        } else {
          That.eventEmit('error', `${this.$t("Common.tips.failure")}`);
        }
        this.getPwdStrategy();
      });
    },
    getPwdStrategy() {
      const url = '/lte/ems/strategy/findPwdStrategy';
      this.axios.get(url).then(response => {
        this.strategyId = response.data.strategyId;
        this.strategyType = response.data.strategyType;
        const result = response.data.items;
        this.passwordByte = result["pwd.minLength"];
        this.passwordRange = result["pwd.updMinTime"];
        this.validTime = result["pwd.period"];
        this.noticeChange = result["pwd.remind"];
        if (result["pwd.updFlag"] === "1") {
          this.$refs.passwordRange.ej2Instances.checked = true;
        } else {
          this.$refs.passwordRange.ej2Instances.checked = false;
          document.getElementById('passwordRange').disabled = true;
        }
        if (result["pwd.expireFlag"] === "1") {
          this.$refs.changePassword.ej2Instances.checked = true;
        } else {
          this.$refs.changePassword.ej2Instances.checked = false;
        }
        if (result["pwd.constitute"] === "1") {
          this.passwordCom = true;
        } else {
          this.passwordCom = false;
        }
      });
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
  mounted() {
    this.formObj = this.validateForm('passwordForm', this.inputNames, this.rules);
    this.getPwdStrategy();
  }
};
</script>
